import { RotateCw } from 'lucide-preact'
import { text } from '#contract'
import { useMediaQuery } from '../app/use-media-query.ts'
import { useView } from '../app/use-view.ts'
import { useT } from '../i18n/index.ts'
import { isTouchPlaying } from '../touch/touch-controls.tsx'
import styles from './rotate-device-prompt.module.css'

/** Covers the game while playing on touch in portrait. Menus still work in portrait. */
export function RotateDevicePrompt() {
  const t = useT()
  const touchPlaying = useView(isTouchPlaying)
  const portrait = useMediaQuery('(orientation: portrait)')
  if (!touchPlaying || !portrait) return null

  return (
    <div class={styles.prompt} role="status">
      <RotateCw class={styles.icon} aria-hidden="true" />
      <p class={styles.title}>{t(text('rotate.title'))}</p>
      <p>{t(text('rotate.body'))}</p>
    </div>
  )
}
